import { Button, Flex, HStack, Text } from "@chakra-ui/react";
import { TransferRequestDetail } from "../schema/transfer-requests.schema";
import { AppColors } from "@/styles/colors";
import { TransferTransactionTypeEnum } from "@/constants/enums";
import { RequestMovementNumber } from "@/components/common/section-components/requests/RequestMovementNumber";
import { useRoles } from "@/hooks/useRoles";
import {  PermissionCode } from "@/constants/permissions";
import { X } from "lucide-react";
import { TransferRequestStatus } from "@/constants/entity-status";

interface Props {
  request?: TransferRequestDetail | null;
  loadingRequest?: boolean;
  loadingRejectRequest?: boolean;
  setOpenRejectModal: (open: boolean) => void;
}

export const TransferTransactionType = ({
  request,
  loadingRejectRequest,
  loadingRequest,
  setOpenRejectModal,
}: Props) => {

  const { userPermissions } = useRoles();

  const hasWriteAccess = Boolean(
    userPermissions?.some(
      (p) =>
        p.codigo === PermissionCode.TRANSFER_REQUEST &&
        p.tipoPermiso === "W",
    ),
  );

  const moreThan1 =
    request?.idMovimientoBIND || hasWriteAccess;


  return (
    <HStack gap="4px" justifyContent={moreThan1 ? "space-between" : "flex-end"}>
      <RequestMovementNumber request={request} />
      <Flex alignItems={"center"} gap="4px">
        <Text className="account-title-label">Transacción: </Text>
        <Text
          className="account-title-label"
          color={
            request?.tipoTransaccion === TransferTransactionTypeEnum.AUTO
              ? AppColors.GREEN_ICON
              : AppColors.YELLOW_SECONDARY
          }
        >
          {request?.tipoTransaccion}
        </Text>
      </Flex>
      {hasWriteAccess && (
        <Button
          disabled={
            loadingRequest ||
            loadingRejectRequest ||
            request?.estado === TransferRequestStatus.REJECTED ||
            request?.estado === TransferRequestStatus.FINISHED
          }
          paddingX="12px"
          paddingY="4px"
          bgColor={AppColors.RED_ICON}
          onClick={() => setOpenRejectModal(true)}
          data-testid="transfer-request-cancel-btn"
        >
          <X />
          <Text
            fontWeight={600}
            fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
          >
            Cancelar
          </Text>
        </Button>
      )}
    </HStack>
  );
};
